export enum ReelsViewEvents {
    REEL_STOPPING_CALLBACK = '__REEL_STOPPING_CALLBACK__',
    REEL_STOPPED = '__REEL_STOPPED__',
    ALL_REELS_STOPPED = '__ALL_REELS_STOPPED__',
    SCATTER_HIT_ANIMATION_PLAYING = '__SCATTER_HIT_ANIMATION_PLAYING__',
    // events for reels animations (stop animations could finish after the reel stops)
    REEL_ANIMATION_FINISHED = '__REEL_ANIMATION_FINISHED__',
    ALL_REEL_ANIMATIONS_FINISHED = '__ALL_REEL_ANIMATIONS_FINISHED__',
};

